<template>
  <svg
    width="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M7,2V13H10V22L17,10H13L17,2H7Z" />
  </svg>
</template>
